<template>
  <v-sheet
    v-if="showSkeletonTable"
    :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-3'}`"
    class="pa-1"
  >
    <v-skeleton-loader
      class="mx-auto"
      max-width
      max-height
      type="table-tbody"
    ></v-skeleton-loader>
  </v-sheet>
</template>

<script>
export default {
  props: {
    showSkeletonTable: Boolean,
  },

  inject: {
    theme: {
      default: { isDark: false },
    },
  },
};
</script>